/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type HeaderQueryVariables = {
    readonly name?: string | null;
};
export type HeaderQueryResponse = {
    readonly v2: {
        readonly organisations: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly id: string;
                    readonly name: string;
                    readonly whitelabelImage: string | null;
                } | null;
            } | null> | null;
        } | null;
    } | null;
};
export type HeaderQuery = {
    readonly response: HeaderQueryResponse;
    readonly variables: HeaderQueryVariables;
};



/*
query HeaderQuery(
  $name: String
) {
  v2 {
    organisations(first: 1, name: $name) {
      edges {
        node {
          id
          name
          whitelabelImage
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "name",
            "type": "String",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "v2",
            "storageKey": null,
            "args": null,
            "concreteType": "V2",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "organisations",
                    "storageKey": null,
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "first",
                            "value": 1
                        },
                        {
                            "kind": "Variable",
                            "name": "name",
                            "variableName": "name"
                        }
                    ],
                    "concreteType": "OrganisationConnection",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "OrganisationEdge",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "node",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "Organisation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "id",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "name",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "whitelabelImage",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "HeaderQuery",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "HeaderQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "query",
            "name": "HeaderQuery",
            "id": null,
            "text": "query HeaderQuery(\n  $name: String\n) {\n  v2 {\n    organisations(first: 1, name: $name) {\n      edges {\n        node {\n          id\n          name\n          whitelabelImage\n        }\n      }\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'fb73a6df755f41b8dc8177fa113ee927';
export default node;
